/**
 * MainLayout - Layout principal de la aplicación
 * Incluye AppBar, Sidebar y área de contenido principal
 */
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const DRAWER_WIDTH = 260;

/**
 * @component MainLayout
 * @description Layout principal con AppBar, Sidebar colapsable y contenido
 * @returns {JSX.Element}
 */
const MainLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  /**
   * Toggle sidebar
   */
  const handleToggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  /**
   * Cerrar sidebar en móvil al navegar
   */
  const handleCloseSidebar = () => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'grey.50' }}>
      {/* Navbar superior */}
      <Navbar
        onToggleSidebar={handleToggleSidebar}
        drawerWidth={DRAWER_WIDTH}
        sidebarOpen={sidebarOpen}
      />

      {/* Sidebar lateral */}
      <Sidebar
        open={sidebarOpen}
        onClose={handleCloseSidebar}
        drawerWidth={DRAWER_WIDTH}
        isMobile={isMobile}
      />

      {/* Contenido principal */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: '100%',
          mt: { xs: 7, sm: 8 },
          transition: theme.transitions.create(['margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          ml: {
            xs: 0,
			md: sidebarOpen ? `10px` : 0,
          },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
